import { getDataUTC, isPeli, getSlug, removeHtmlTags, dataResources } from '@portal-internet/core';
import { useProducte } from 'hooks/3cat/useProducte';
import { useRouter } from 'next/router';
import __escape from 'lodash/escape';
import { getImatge } from '@portal-internet/components';

const SCHEMA_ORG = 'https://schema.org';
const LOGO_3CAT = 'https://statics.3cat.cat/recursos/img/logos/metadades/logo_3cat.png',
    TRESCATINFO = '3catinfo',
    TRESCAT = '3Cat',
    TV3 = 'TV3',
    ESPORT3 = 'Esport 3',
    CR = 'Catalunya Ràdio',
    CATRADIO = 'Catradio',
    CM = 'Catalunya Música',
    SX3 = 'SX3',
    C33 = '33',
    ICAT = 'Icat',
    EVA = 'eva',
    CATRADIOURL = '/catradio/';

const _getCurrentUrl = (router) => {
    let url = router.asPath,
        indexParams = url.indexOf('?');
    url = indexParams > 0 ? url.substring(0, indexParams) : url;
    return '//' + dataResources.domainCCMA + url;
};
const _getHomeObjectSchema = (router, subtype) => {
    const name = subtype === EVA ? 'Eva' : TRESCAT;
    const alternateName = subtype === EVA ? 'Som Eva' : '';
    const logo =
        subtype === EVA
            ? [
                  [
                      {
                          '@type': 'ImageObject',
                          'url': 'https://statics.3cat.cat/recursos/img/logos/metadades/logo_eva.png'
                      }
                  ]
              ]
            : [
                  {
                      '@type': 'ImageObject',
                      'url': LOGO_3CAT
                  }
              ];
    const sameAs =
        subtype === EVA
            ? [
                  'https://www.instagram.com/someva__/',
                  'https://www.tiktok.com/@someva__?lang=ca',
                  'https://www.twitch.tv/someva_',
                  'https://www.youtube.com/@SomEVA',
                  'https://ca.wikipedia.org/wiki/EVA_(plataforma_juvenil)'
              ]
            : [
                  'https://www.facebook.com/som3Cat',
                  'https://x.com/som3cat',
                  'https://www.instagram.com/som3cat/',
                  'https://www.youtube.com/@som3cat',
                  'https://ca.wikipedia.org/wiki/3Cat',
                  'https://ca.wikipedia.org/wiki/Corporaci%C3%B3_Catalana_de_Mitjans_Audiovisuals',
                  'https://news.google.com/publications/CAAqIQgKIhtDQklTRGdnTWFnb0tDRE5qWVhRdVkyRjBLQUFQAQ?hl=ca-ES&gl=ES&ceid=ES%3Aca'
              ];
    const subOrganizations =
        subtype === EVA
            ? []
            : [
                  {
                      '@type': 'Organization',
                      'name': TRESCATINFO,
                      'url': 'https://www.3cat.cat/3catinfo/'
                  },
                  {
                      '@type': 'Organization',
                      'name': ESPORT3,
                      'url': 'https://www.3cat.cat/esport3/'
                  },
                  {
                      '@type': 'Organization',
                      'name': SX3,
                      'url': 'https://www.3cat.cat/tv3/sx3/'
                  },
                  {
                      '@type': 'Organization',
                      'name': TV3,
                      'url': 'https://www.3cat.cat/tv3/'
                  },
                  {
                      '@type': 'Organization',
                      'name': CATRADIO,
                      'url': 'https://www.3cat.cat/catradio/'
                  },
                  {
                      '@type': 'Organization',
                      'name': 'Eva',
                      'url': 'https://www.3cat.cat/3cat/eva/'
                  }
              ];

    const parentOrganization =
        subtype === EVA
            ? {
                  '@type': 'Organization',
                  'name': TRESCAT,
                  'url': 'https://www.3cat.cat/3cat/',
                  'logo': {
                      '@type': 'ImageObject',
                      'url': LOGO_3CAT,
                      'height': 95,
                      'width': 302
                  }
              }
            : '';
    const schemaData = {
        '@context': SCHEMA_ORG,
        '@type': 'Organization',
        'name': name,
        'sameAs': sameAs,
        'url': _getCurrentUrl(router),
        'logo': logo,
        'publishingprinciples': 'https://www.3cat.cat/llibredestil/guia-editorial/3100467/',
        'diversitypolicy': 'https://www.3cat.cat/llibredestil/diversitat/3100252/',
        'correctionspolicy': 'https://www.3cat.cat/llibredestil/correccions/3100459/',
        'ethicspolicy': 'https://www.3cat.cat/llibredestil/principis-editorials/3100232/',
        'contactpoint': {
            '@type': 'ContactPoint',
            'contactType': 'Atenció al públic',
            'url': 'https://www.3cat.cat/atencio/',
            'telephone': '+34-93-884-4488',
            'availableLanguage': ['ca', 'es'],
            'areaServed': {
                '@type': 'AdministrativeArea',
                'name': 'Catalunya',
                'sameAs': ['https://www.wikidata.org/wiki/Q5705', 'https://en.wikipedia.org/wiki/Catalonia']
            }
        }
    };

    if (alternateName) schemaData['alternateName'] = alternateName;
    if (subOrganizations.length > 0) schemaData['subOrganization'] = subOrganizations;
    if (parentOrganization) schemaData['parentOrganization'] = parentOrganization;

    return schemaData;
};
const _getNoticiaObjectSchema = (props, router) => {
    const { titol, entradeta, cos, imatges, domini, autors, redactor, dataModificacio, dataPublicacio } = props;
    const getDades = () => {
        let autor = 'Redacció 324';
        let logoUrl = 'https://img.3cat.cat/multimedia/png/0/0/1543404122600.png';
        let logoWidth = 150;
        let logoHeight = 60;
        let logoName = '324';
        let urlPublisher = '//' + dataResources.domainCCMA + '/324';
        switch (domini) {
            case 'MET':
                autor = 'Redacció El temps';
                break;
            case 'PUCR':
            case 'WCR':
                autor = 'Redacció Catalunya Ràdio';
                logoUrl = 'https://img.3cat.cat/multimedia/jpg/8/5/1457533676558.jpg';
                logoWidth = 235;
                logoHeight = 101;
                logoName = CR;
                urlPublisher = '//' + dataResources.domainCCMA + '/catradio';
                break;
            case 'PUS3':
            case 'SP3':
            case 'TAG':
                autor = 'Redacció Super3';
                logoUrl = 'https://img.3cat.cat/multimedia/jpg/8/8/1457534811588.jpg';
                logoWidth = 288;
                logoHeight = 201;
                logoName = 'Super3';
                urlPublisher = '//' + dataResources.domainCCMA + '/tv3/super3';
                break;
            case 'PUE3':
            case 'ESP':
                autor = 'Redacció Esport3';
                logoUrl = 'https://img.3cat.cat/multimedia/jpg/1/1/1672220093611.jpg';
                logoWidth = 424;
                logoHeight = 250;
                logoName = 'Esport3';
                urlPublisher = '//' + dataResources.domainCCMA + '/esport3';
                break;
            case 'PUCC':
            case 'PUTR':
            case 'CCRTV':
                autor = 'Redacció CCMA';
                logoUrl = 'https://img.3cat.cat/multimedia/jpg/4/1/1457534753314.jpg';
                logoWidth = 353;
                logoHeight = 111;
                logoName = 'CCMA';
                urlPublisher = '//' + dataResources.domainCCMA;
                break;
            case 'PUPUB':
            case 'PUSP':
                autor = 'Redacció CCMA';
                logoUrl = 'https://img.3cat.cat/multimedia/jpg/8/5/1453905492658.jpg';
                logoWidth = 526;
                logoHeight = 181;
                logoName = 'CCMA';
                urlPublisher = '//' + dataResources.domainCCMA;
                break;
            case 'TVC':
                autor = 'Redacció TV3';
                logoUrl = 'https://img.3cat.cat/multimedia/jpg/6/4/1457533639546.jpg';
                logoWidth = 140;
                logoHeight = 118;
                logoName = TV3;
                urlPublisher = '//' + dataResources.domainCCMA + '/tv3';
                break;
        }
        autor = redactor !== '' ? redactor : autor;
        autor = autors ? autors[0].desc : autor;
        const autorDomini = domini === 'PUCR' ? 'catradio' : 'tv3';
        const autorUrl = autors
            ? 'https://' + dataResources.domainCCMA + '/' + autorDomini + '/' + getSlug(autors[0].desc) + '/autor/' + autors[0].id
            : '';

        return {
            autor: autor,
            autorDomini: autorDomini,
            autorUrl: autorUrl,
            logoUrl: logoUrl,
            logoWidth: logoWidth,
            logoHeight: logoHeight,
            logoName: logoName,
            imatge: getImatge(imatges, 'web_destacat', null, 1200),
            urlPublisher: urlPublisher
        };
    };
    const dades = getDades();

    const schemaData = {
        '@context': SCHEMA_ORG,
        '@type': 'NewsArticle',
        'mainEntityOfPage': {
            '@type': 'WebPage',
            '@id': _getCurrentUrl(router)
        },
        'url': _getCurrentUrl(router),
        'description': entradeta,
        'articleBody': __escape(removeHtmlTags(cos)),
        'publisher': {
            '@type': 'Organization',
            'name': dades.logoName,
            'url': dades.urlPublisher,
            'logo': {
                '@type': 'ImageObject',
                'url': dades.logoUrl,
                'height': dades.logoHeight,
                'width': dades.logoWidth
            }
        },
        'author': [
            {
                '@type': 'Person',
                'name': dades.autor
            }
        ],
        'headline': titol,
        'image': [
            {
                '@type': 'ImageObject',
                'url': dades.imatge,
                'width': 1200,
                'height': 677
            }
        ]
    };
    if (dades.autorUrl) schemaData['author'][0]['url'] = dades.autorUrl;
    if (dataPublicacio) schemaData['datePublished'] = getDataUTC(dataPublicacio);
    if (dataModificacio) schemaData['dateModified'] = getDataUTC(dataModificacio);
    return schemaData;
};

const _getVideoAudioObjectSchema = (props, router) => {
    const {
        type,
        titol,
        entradeta,
        entradetaPromo,
        durada,
        dataPublicacio,
        dataModificacio,
        dataCaducitat,
        nomPrograma,
        imatges,
        formats,
        embed,
        tipologia,
        eventsTranscripcio
    } = props;

    const getEmbedUrl = () => {
        return `https://${dataResources.domainCCMA}/3cat/video/${router.query.id}/embed/?tipus_embed=google`;
    };

    const getItemEmbedUrl = (tipologia) => {
        const tipologiaItem = tipologia === 'WCR_AUDIO_MM' ? 'audio' : 'video';
        return `https://${dataResources.domainCCMA}/3cat/${tipologiaItem}/${router.query.id}/embed/`;
    };

    const getThumbnail = (posMida = 0) => {
        const arrMides = ['670x378', '426x240', '326x184', '320x180', '200x113', '120x68'];
        if (posMida >= arrMides.length || !imatges)
            return 'https://statics.3cat.cat/recursos/3play/img/videos_recurs_640x360.jpg';
        const imatge = imatges.find(({ mida }) => mida === arrMides[posMida]);
        if (imatge) return imatge.text;
        return getThumbnail(posMida + 1);
    };

    const getDurada = () => {
        const arrDurada = durada.split(':');
        return `PT${arrDurada[0]}H${arrDurada[1]}M${arrDurada[2]}S`;
    };

    const getName = () => {
        const prefix = !isPeli(formats) && nomPrograma ? `${nomPrograma} - ` : '';
        return prefix + titol;
    };

    const schemaData = {
        '@context': SCHEMA_ORG,
        '@type': type,
        'mainEntityOfPage': {
            '@type': 'WebPage',
            '@id': _getCurrentUrl(router)
        },
        'name': getName(),
        'description': entradetaPromo || entradeta,
        'thumbnailUrl': getThumbnail(),
        'uploadDate': getDataUTC(dataPublicacio),
        'duration': getDurada(),
        'publisher': {
            '@type': 'Organization',
            'name': TRESCAT,
            'logo': {
                '@type': 'ImageObject',
                'url': LOGO_3CAT,
                'height': 95,
                'width': 302
            }
        },
        'creator': nomPrograma,
        'url': _getCurrentUrl(router),
        'embedUrl': getItemEmbedUrl(tipologia),
        'contentUrl': _getCurrentUrl(router)
    };

    if (dataModificacio) schemaData['dateModified'] = getDataUTC(dataModificacio);
    if (dataCaducitat) schemaData['expires'] = getDataUTC(dataCaducitat);
    if (embed) schemaData.embedUrl = getEmbedUrl();
    if (Array.isArray(eventsTranscripcio) && eventsTranscripcio.length > 0) {
        schemaData['transcript'] = eventsTranscripcio.map((event) => event.text).join(' ');
    }
    return schemaData;
};

const _getBroadcastServiceSchema = (props, router) => {
    const { type, canalDirecte } = props;

    const getDades = () => {
        let nomEntitat = '3Cat Directes';
        let broadcastDisplayName = '3Cat - Directes';
        let descripcio = 'Servei de televisió i streaming en directe de 3cat.';
        let broadcasterType = 'Organization';
        let broadcasterName = TRESCAT;
        let broadcasterUrl = dataResources.domainCCMA + '/3cat/';
        const textDescripcio = 'Servei de directes';
        const broadcastTimezone = 'Europe/Madrid';
        const idioma = 'ca';
        switch (canalDirecte) {
            case '324':
                nomEntitat = TRESCATINFO;
                broadcastDisplayName = TRESCATINFO;
                descripcio = `${textDescripcio} de ${TRESCATINFO}, televisió`;
                broadcasterType = 'NewsMediaOrganization';
                broadcasterName = TRESCATINFO;
                broadcasterUrl = dataResources.domainCCMA + '/3catinfo/';
                break;
            case 'tv3':
                nomEntitat = TV3;
                broadcastDisplayName = TV3;
                descripcio = `${textDescripcio} de ${TV3}`;
                broadcasterName = TV3;
                broadcasterUrl = dataResources.domainCCMA + '/tv3/';
                break;
            case 'cr':
                nomEntitat = CR;
                broadcastDisplayName = CR;
                descripcio = `${textDescripcio} de ${CR}`;
                broadcasterName = CATRADIO;
                broadcasterUrl = dataResources.domainCCMA + CATRADIOURL;
                break;
            case 'esport3':
                nomEntitat = ESPORT3;
                broadcastDisplayName = ESPORT3;
                descripcio = `${textDescripcio} de l'${ESPORT3}`;
                broadcasterName = ESPORT3;
                broadcasterUrl = dataResources.domainCCMA + '/esport3/';
                break;
            case 'ci':
                nomEntitat = TRESCATINFO;
                broadcastDisplayName = TRESCATINFO;
                descripcio = `${textDescripcio} de ${TRESCATINFO}, ràdio`;
                broadcasterType = 'NewsMediaOrganization';
                broadcasterName = TRESCATINFO;
                broadcasterUrl = dataResources.domainCCMA + '/3catinfo/';
                break;
            case 'sx3':
                nomEntitat = SX3;
                broadcastDisplayName = SX3;
                descripcio = `${textDescripcio} del canal ${SX3}`;
                broadcasterName = SX3;
                broadcasterUrl = dataResources.domainCCMA + '/tv3/sx3/';
                break;
            case 'ic':
                nomEntitat = ICAT;
                broadcastDisplayName = ICAT;
                descripcio = `${textDescripcio} d'${ICAT}`;
                broadcasterName = CATRADIO;
                broadcasterUrl = dataResources.domainCCMA + CATRADIOURL;
                break;
            case 'c33':
                nomEntitat = C33;
                broadcastDisplayName = C33;
                descripcio = `${textDescripcio} del canal ${C33}`;
                break;
            case 'cm':
                nomEntitat = CM;
                broadcastDisplayName = CM;
                descripcio = `${textDescripcio} de ${CM}`;
                broadcasterName = CATRADIO;
                broadcasterUrl = dataResources.domainCCMA + CATRADIOURL;
                break;
        }
        return {
            nomEntitat: nomEntitat,
            broadcastDisplayName: broadcastDisplayName,
            descripcio: descripcio,
            broadcasterType: broadcasterType,
            broadcasterName: broadcasterName,
            broadcasterUrl: broadcasterUrl,
            broadcastTimezone: broadcastTimezone,
            idioma: idioma
        };
    };
    const dades = getDades();

    const getBroadcastChannel = () => {
        const typeChannel = 'BroadcastChannel';
        const type = 'BroadcastService';
        const url3CatDirectes = 'https://www.3cat.cat/3cat/directes/';
        const broadcastChannel = [
            {
                '@type': typeChannel,
                'name': TRESCATINFO,
                'providesBroadcastService': {
                    '@type': type,
                    'name': TRESCATINFO,
                    'url': url3CatDirectes + '3catinfo-tv/'
                }
            },
            {
                '@type': typeChannel,
                'name': TV3,
                'providesBroadcastService': {
                    '@type': type,
                    'name': TV3,
                    'url': url3CatDirectes + 'tv3/'
                }
            },
            {
                '@type': typeChannel,
                'name': CR,
                'providesBroadcastService': {
                    '@type': type,
                    'name': CR,
                    'url': url3CatDirectes + 'catalunya-radio/'
                }
            },
            {
                '@type': typeChannel,
                'name': ESPORT3,
                'providesBroadcastService': {
                    '@type': type,
                    'name': ESPORT3,
                    'url': url3CatDirectes + 'esport3/'
                }
            },
            {
                '@type': typeChannel,
                'name': TRESCATINFO,
                'providesBroadcastService': {
                    '@type': type,
                    'name': TRESCATINFO,
                    'url': url3CatDirectes + '3catinfo-radio/'
                }
            },
            {
                '@type': typeChannel,
                'name': SX3,
                'providesBroadcastService': {
                    '@type': type,
                    'name': SX3,
                    'url': url3CatDirectes + 'sx3/'
                }
            },
            {
                '@type': typeChannel,
                'name': ICAT,
                'providesBroadcastService': {
                    '@type': type,
                    'name': ICAT,
                    'url': url3CatDirectes + 'icat/'
                }
            },
            {
                '@type': typeChannel,
                'name': C33,
                'providesBroadcastService': {
                    '@type': type,
                    'name': C33,
                    'url': url3CatDirectes + '33/'
                }
            },
            {
                '@type': typeChannel,
                'name': CM,
                'providesBroadcastService': {
                    '@type': type,
                    'name': CM,
                    'url': url3CatDirectes + 'catalunya-musica/'
                }
            }
        ];
        return broadcastChannel;
    };

    const schemaData = {
        '@context': SCHEMA_ORG,
        '@type': type,
        'name': dades.nomEntitat,
        'broadcastDisplayName': dades.broadcastDisplayName,
        'description': dades.descripcio,
        'url': _getCurrentUrl(router),
        'broadcaster': {
            '@type': dades.broadcasterType,
            'name': dades.broadcasterName,
            'url': dades.broadcasterUrl
        },
        'broadcastTimezone': dades.broadcastTimezone,
        'inLanguage': dades.idioma
    };

    if (!canalDirecte) schemaData['hasBroadcastChannel'] = getBroadcastChannel();

    return schemaData;
};

export default function MarcatgeEstructurat(props) {
    const { type, subType } = props;
    const { isWebviewActive } = useProducte();
    const router = useRouter();
    let schemaData = null;

    if (isWebviewActive) return <></>;

    switch (type) {
        case 'HomeObject':
            schemaData = _getHomeObjectSchema(router, subType);
            break;
        case 'VideoObject':
        case 'AudioObject':
            schemaData = _getVideoAudioObjectSchema(props, router);
            break;
        case 'NewsArticle':
            schemaData = _getNoticiaObjectSchema(props, router);
            break;

        case 'BroadcastService':
            schemaData = _getBroadcastServiceSchema(props, router);
            break;
    }

    return (
        <>
            <script type='application/ld+json' dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }} />
        </>
    );
}
